import { MutationOptions, useMutation, useQueryClient } from "react-query"
import { useApiClient } from "../../api-client/api-client.hooks"
import { TApiGenericError } from "../../timenotes-query/timenotes-query.types"
import { TApiProjectSection } from "../../api-client/types"

interface Args extends Partial<TApiProjectSection> {}

interface UseCreateProjectSectionMutationParams {
  projectId: string
}

const useCreateProjectSectionMutation = (params: UseCreateProjectSectionMutationParams, options?: MutationOptions<any,any,any>) => {
  const apiClient = useApiClient()
  const queryClient = useQueryClient()

  const {
    projectId
  } = params

  const mutation = useMutation<{}, TApiGenericError<any>, Args>(
    ["create-section"],
    async (args: Args) => {
      const { name } = args 

      const response = await apiClient.createSection(projectId, name)

      if (!response.ok) {
        throw response.errors
      }

      return response
    },
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries(["project-sections", projectId], {
          exact: false,
        })

        if (options.onSuccess) options.onSuccess(...args)
      },
    }
  )

  return mutation
}

export default useCreateProjectSectionMutation